import { render, staticRenderFns } from "./publicQuestion.vue?vue&type=template&id=4e474993&scoped=true&"
import script from "./publicQuestion.vue?vue&type=script&lang=js&"
export * from "./publicQuestion.vue?vue&type=script&lang=js&"
import style0 from "./publicQuestion.vue?vue&type=style&index=0&id=4e474993&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e474993",
  null
  
)

export default component.exports